import { useContext } from 'react';
import { CurrentEditorContext } from './CurrentEditorContext';

export const useCurrentEditorContext = () => {
  const currentEditorContext = useContext(CurrentEditorContext);
  if (currentEditorContext === undefined) {
    throw new Error('useCurrentEditorContext must be inside a CurrentEditorProvider');
  }
  return currentEditorContext;
};
